export function tryFunctionOrLogError(f) {
    try {
        return f();
    }
    catch (e) {
        if (console.error) {
            console.error(e);
        }
    }
}
export function graphQLResultHasError(result) {
    return result.errors && result.errors.length > 0;
}
//# sourceMappingURL=errorHandling.js.map